<div class="container">
    <div class="file-upload" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
        <input
            #fileInput
            type="file"
            (change)="onFileUploadedChanged($event.target.files); resetFiles($event)"
            hidden
            [accept]="acceptedExtensions"
        />
        <span class="ham-icon"> <i class="upload-icon"></i></span>

        <p><ng-content> </ng-content></p>

        <a class="link" (click)="fileInput.click()">{{ 'aumico_reports_browse_files' | i18next }}</a>

        <span class="extension-error" *ngIf="fileExtensionError"
            >{{ 'aumico_reports_companies_upload_file_upload_error_format' | i18next }}
        </span>
    </div>
</div>
